import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Heading,
  SimpleGrid,
  Text,
  VStack,
  Link,
  useToast,
} from '@chakra-ui/react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { useAuth } from '../../context/AuthContext';
import { Quiniela } from '../../types';

const QuinielaList: React.FC = () => {
  const [quinielas, setQuinielas] = useState<Quiniela[]>([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const toast = useToast();

  useEffect(() => {
    const fetchQuinielas = async () => {
      try {
        const q = query(
          collection(db, 'quinielas'),
          where('participants', 'array-contains', user?.uid)
        );
        const querySnapshot = await getDocs(q);
        const quinielasData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })) as Quiniela[];
        
        setQuinielas(quinielasData);
      } catch (error) {
        toast({
          title: 'Error al cargar las quinielas',
          status: 'error',
          duration: 3000,
        });
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      fetchQuinielas();
    }
  }, [user, toast]);

  if (loading) {
    return <Text>Cargando quinielas...</Text>;
  }

  return (
    <Box p={4}>
      <VStack spacing={6} align="stretch">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Heading size="lg">Mis Quinielasssss</Heading>
          <Button
            as={RouterLink}
            to="/quiniela/new"
            colorScheme="blue"
          >
            Crear Quiniela
          </Button>
        </Box>

        {quinielas.length === 0 ? (
          <Text>No hay quinielas disponibles.</Text>
        ) : (
          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
            {quinielas.map((quiniela) => (
              <Box
                key={quiniela.id}
                p={5}
                shadow="md"
                borderWidth="1px"
                borderRadius="lg"
              >
                <VStack align="stretch" spacing={3}>
                  <Heading size="md">{quiniela.name}</Heading>
                  <Text>
                    Partidos: {quiniela.matches?.length || 0}
                  </Text>
                  <Text>
                    Participantes: {quiniela.participants?.length || 0}
                  </Text>
                  <Button
                    as={RouterLink}
                    to={`/quiniela/${quiniela.id}`}
                    colorScheme="blue"
                    variant="outline"
                  >
                    Ver Detalles
                  </Button>
                </VStack>
              </Box>
            ))}
          </SimpleGrid>
        )}
      </VStack>
    </Box>
  );
};

export default QuinielaList; 